window.order = {
    init(){
        window.addEventListener('screenshot_ready', function(e){
            window.order.screenshot = e.detail;
            canvasTool.generateZipContent().then(function (base64) {
                window.order.zip = "data:application/zip;base64," + base64;

                window.order.process();
            });
        })

        return this;
    },
    validate(settings) {
        let isValid = true;

        //validate nodes
        let validateNodes = [
            this.validateContact()
        ];
        for (const nodeValid of validateNodes) {
            isValid = isValid && nodeValid;
        }

        if (isValid) {
            this.settings = settings; //load validated settings
        }

        return isValid;
    },
    getFormContact() {
        return document.querySelector('#order_contact');
    },
    validateContact() {
        let isContactFormValid = true;
        const formOrderContact = this.getFormContact();

        //order form validation
        for (const el of formOrderContact.elements) {
            isContactFormValid = isContactFormValid && el.validity.valid;
        }

        if (false === isContactFormValid) {
            formOrderContact.querySelector('input[type="submit"]').click();
        }

        return isContactFormValid;
    },
    async process() {
        window.dispatchEvent(new CustomEvent('app_order_process'));

        let data = new FormData(this.getFormContact());
        data.append('settings', JSON.stringify(this.settings));
        data.append('screenshot', this.screenshot);
        data.append('zip', this.zip);
        data.append('configurator_link', window.location.href);

        let response = await fetch('ignore/api/post/order.php', { method: 'POST', body: data });
        if(response.ok){
            const body = await response.json();
            window.dispatchEvent(new CustomEvent('app_order_finished'));
        }
    }
}.init();